export type DefaultClientTableColumnKey =
  | 'inventory'
  | 'status'
  | 'assignee'
  | 'client-user'
  | 'client-groups'
  | 'description';

export const defaultClientTableColumnKeys: DefaultClientTableColumnKey[] = [
  'inventory',
  'status',
  'assignee',
  'client-user',
  'client-groups',
  'description',
];

export const getDefaultClientTableColums = (
  i18n: ReturnType<typeof useI18n>
) => {
  return defaultClientTableColumnKeys.map((_id) => {
    return {
      _id,
      name: i18n.t('general.' + _id),
    };
  });
};
